// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__3n_ym","title":"Images90_title__1nY_r","images":"Images90_images__2QMfS"};